import React from 'react';
import {
  Button,
  ButtonColorVariant,
  ButtonSize,
  ButtonVariant,
  withCitrusTheme,
} from '@gousto-internal/citrus-react';

type CarouselArrowDirection = 'prev' | 'next';

type CarouselArrowButtonProps = {
  direction: CarouselArrowDirection;
  onClick: () => void;
  'aria-label': string;
  className?: string;
};

const RoundButton = withCitrusTheme(Button, () => ({
  borderRadius: '50%',
}));

export function CarouselArrowButton({
  direction,
  onClick,
  'aria-label': ariaLabel,
  className,
}: CarouselArrowButtonProps): JSX.Element {
  return (
    <RoundButton
      type="button"
      className={className}
      aria-label={ariaLabel}
      onClick={onClick}
      variant={ButtonVariant.Icon}
      colorVariant={ButtonColorVariant.Secondary}
      size={ButtonSize.Large}
      icon={direction === 'prev' ? 'arrow_back' : 'arrow_right'}
    />
  );
}
